<template>
    <div class="copy-plan-container">
        <template v-if="isPageAllowed">
            <component :is="currentPages" :page-func-names="pageFuncNames" :ref="currentPages"
            @refresh="refreshPage"
            />
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面展示OPPO媒体相关数据内容与广告管理。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>
<script>
import ListPage from './page/copyListPage'
import InfoPage from './page/copyInfoPage'
import CreatePage from './page/copyCreatePage'
import NoPermissionInfo from '@/components/noPermissionInfo';
import { pageMixin } from '@/views/mixins/pageMixin';
import NProgress from 'nprogress' // progress bar
import _ from 'lodash';
export default {
    name: "CopyPlan",
    mixins: [pageMixin],
    components: {
        List: ListPage,
        Info: InfoPage,
        Create: CreatePage,
        Copy: CreatePage,
        NoPermissionInfo
    },
    data() {
        return {
            currentPages: 'List',
            keeps: ['List'], //,'AssignPage','TaskPage'
            type: false, // 区分是否弹出阻止窗口
        }
    },
    watch: {
        $route: {
            handler(to, from, next) {
                this.currentPages = to.params?.type ? _.capitalize(to.params.type) : 'List'
                this.keeps = to.query?.topage ? [] : ['List']
                if(to.params?.type == 'info' || to.params?.type == 'copy') {
                    this.keeps = ['List']
                }else if(to.params?.type == 'create') {
                    this.keeps = []
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {

    },
    methods: {
        refreshPage(value) {
            this.type = value
        }
        // 手动触发路由离开守卫
        // triggerRouteLeave(to, from) {
        //     const next = (allow) => {
        //         if (allow) {
        //             this.$router.push(to);
        //         }
        //     };
            
        //     this.$confirm('您确定要离开吗？', '温馨提示', {
        //         confirmButtonText: '离开',
        //         type: 'warning',
        //         showClose: false,
        //         closeOnClickModal: false,
        //         closeOnPressEscape: false
        //     }).then(() => {
        //         next(true);
        //     }).catch(() => {
        //         next(false);
        //     });
        // }
    },
    // beforeRouteEnter(to, from, next) {
    //         console.log('beforeRouteEnter', to, from)
    //         next();
    // },
    async beforeRouteUpdate (to, from, next) {
        
        // 浏览器回退
        if(from?.params?.type == 'copy') {
            let isEqual = await this.$refs[this.currentPages]?.getCurrentChangeStates()
            if(!isEqual && !this.type) {
                this.$confirm('您确定要离开吗？', '温馨提示', {
                    confirmButtonText: '离开',
                    type: 'warning',
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false
                }).then(() => {
                    next();
                }).catch(() => {
                    NProgress.done()
                    next(false);
                });
            }else{
                next();
            }
        }else{
            next()
        }
    },
    // beforeRouteLeave(to, from, next) {
    //     if(from?.params?.type == 'copy') {
    //             this.$confirm('您确定要离开吗？', '温馨提示', {
    //             confirmButtonText: '离开',
    //             type: 'warning',
    //             showClose: false,
    //             closeOnClickModal: false,
    //             closeOnPressEscape: false
    //         }).then(() => {
    //             next();
    //         }).catch(() => {
    //             NProgress.done()
    //             next(false);
    //         });
    //     }else{
    //         next()
    //     }
    // },
}

</script>
